import Layout from "../cponents/layout";
import { useHistory } from "react-router-dom";
import useAuthUser from "../hooks/useAuthUser";
import { FaPlay } from "react-icons/fa";
import { useEffect, useState } from "react";
import BaseEndpoint from "../endpoints/baseEndpoint";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import PotentialTestFinish from "./finish/potentialTest";
import PotensiKerjaFinish from "./finish/potensiKerja";
import SpecialPotentialTestFinish from "./finish/specialPotentialTest";
import TesAkademikFinish from "./finish/tesAkademik";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function Finish() {
    const router = useHistory();
    const { user } = useAuthUser();

    const [hasil, setHasil] = useState(null)

    useEffect(() => {
        localStorage.removeItem('session');
        localStorage.removeItem('answer');
        localStorage.removeItem('mapping');

        BaseEndpoint.instance().post(`/exam/${user.version}/finish`, {
            'token': user.token
        }).then((response) => {
            let newData = { ...response.data }
            // newData['Potensi Inteligensi']['KEMAMPUAN ANALISIS']['Benar'] = 3;
            // newData['Potensi Inteligensi']['KEMAMPUAN BERHITUNG PRAKTIS']['Benar'] = 8;
            // newData['Potensi Inteligensi']['LOGIKA BERPIKIR']['Benar'] = 5;
            setHasil(newData)
        })
    }, [])

    return (
        <Layout>
            {/* <div className="container mx-auto row items-center" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                <div className="col-md-6 d-flex flex-column justify-content-center align-items-center">
                    <img src="/assets/images/login.svg" alt="" className="img-fluid w-100" style={{ maxWidth: "350px", objectFit: "contain" }} />
                    <div className="mt-5">
                        <p className="text-secondary" style={{ fontSize: "1.2rem" }}>Selamat anda telah menyelesaikan seluruh rangkaian ujian.</p>
                        {hasil?.penilaian ? (
                            <>
                                <div dangerouslySetInnerHTML={{ __html: hasil?.penilaian }}></div>
                            </>
                        ) : (
                            <h3 className="mb-4" style={{ fontSize: "1.5rem", textTransform: "uppercase", lineHeight: 1.8, fontWeight: 700, }}>HASIL NILAI TOTAL MASIH DI OLAH OLEH SERVER, ANDA BISA MENGHUBUNGI ADMIN DAN MENUNGGU MAKSIMAL 3X24 JAM.</h3>
                        )}
                    </div>
                </div>
                <div className="col-md-6 d-flex flex-column justify-content-center">
                    <div className="mt-2 border rounded p-5 bg-white">
                        <h1 className="fw-bold mb-5 text-center text-secondary" style={{ textTransform: "uppercase", fontSize: '1.5rem' }}>Ringkasan hasil ujian anda</h1>
                        <table className="table borderless" style={{ margin: "auto" }}>
                            <tbody>
                                <tr>
                                    <td>Nama</td>
                                    <td>{user?.nama_lengkap}</td>
                                </tr>
                                <tr>
                                    <td>No. Telepon</td>
                                    <td>{user?.no_tlp || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Alamat email</td>
                                    <td>{user?.email || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Tempat & Tanggal Lahir</td>
                                    <td>{user?.ttl || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Jenis Kelamin</td>
                                    <td>{getGender(user?.jenis_kelamin) || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Versi Ujian</td>
                                    <td>{getExamVersion(user?.version) || '-'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="row container mx-auto mt-2 mb-1 border rounded p-5 bg-white">
                <div className="row mx-auto mt-2">
                    <h2 className="text-center mb-5">Potensi Inteligensi</h2>
                </div>
                <div className="row mx-auto mb-5">
                    <div className="col-md-6">
                        <h3 className="text-center mb-4 text-secondary" style={{ textTransform: 'uppercase', fontSize: '.9rem' }}>Hasil Jawab</h3>
                        <table className="table table-bordered" style={{ margin: "auto" }}>
                            <thead>
                                <tr>
                                    <th className="text-center">Kategori Soal</th>
                                    <th className="text-center">Skor total benar</th>
                                    <th className="text-center">Skor hasil kerja</th>
                                    <th className="text-center">Keterangan</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hasil !== null && Object.entries(hasil['Potensi Inteligensi']).map(([key, value]) => {
                                    return (
                                        <tr key={key}>
                                            <td className="text-center">{key}</td>
                                            <td className="text-center">{value['Jumlah Soal']}</td>
                                            <td className="text-center">{value['Benar']}</td>
                                            <td className="text-center">{value['Keterangan']}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-6">
                        <h3 className="text-center mb-4 text-secondary" style={{ textTransform: 'uppercase', fontSize: '.9rem' }}>Kategori kemampuan berdasarkan hasil jawab</h3>
                        <table className="table table-bordered" style={{ margin: "auto", width: "100%" }}>
                            <thead>
                                <tr>
                                    <th rowSpan={2} className="text-center" style={{ width: "40%" }}>Kategori Soal</th>
                                    <th colSpan={5} className="text-center">Skor total benar</th>
                                </tr>
                                <tr>
                                    <th className="text-center" style={{ width: "12%" }}>RS</th>
                                    <th className="text-center" style={{ width: "12%" }}>R</th>
                                    <th className="text-center" style={{ width: "12%" }}>S</th>
                                    <th className="text-center" style={{ width: "12%" }}>T</th>
                                    <th className="text-center" style={{ width: "12%" }}>TS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hasil !== null && Object.entries(hasil['Potensi Inteligensi']).map(([key, value]) => {
                                    return (
                                        <tr key={key}>
                                            <td className="text-center">{key}</td>
                                            <td className="text-center" style={{ position: 'relative' }}>
                                                {(() => {
                                                    let nilai = Object.keys(value['List Point Kategori']);
                                                    let grafik = value['Grafik'];
                                                    let index = nilai.indexOf(grafik);

                                                    return (
                                                        <span className="bg-primary" style={{ position: 'absolute', top: '30%', left: 0, width: ((index + 1) * 100) + '%', height: '18px' }}></span>
                                                    )
                                                })()}
                                            </td>
                                            <td className="text-center">

                                            </td>
                                            <td className="text-center">

                                            </td>
                                            <td className="text-center">

                                            </td>
                                            <td className="text-center">

                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="row container mx-auto mt-3 mb-2 border rounded p-5 bg-white">
                <div className="mx-auto mt-2">
                    <h2 className="text-center mb-5">Karakter Pribadi</h2>
                </div>
                <div className="row mx-auto mb-5">
                    <div className="col-md-6">
                        <h3 className="text-center mb-4 text-secondary" style={{ textTransform: 'uppercase', fontSize: '.9rem' }}>Hasil Jawab</h3>
                        <table className="table table-bordered" style={{ margin: "auto" }}>
                            <thead>
                                <tr>
                                    <th className="text-center">Kategori Soal</th>
                                    <th className="text-center">Skor total benar</th>
                                    <th className="text-center">Skor hasil kerja</th>
                                    <th className="text-center">Keterangan</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hasil !== null && Object.entries(hasil['Karakter Pribadi']).map(([key, value]) => {
                                    return (
                                        <tr key={key}>
                                            <td className="text-center">{key}</td>
                                            <td className="text-center">{value['Point Soal']}</td>
                                            <td className="text-center">{value['Point Token']}</td>
                                            <td className="text-center">{value['Keterangan']}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-6">
                        <h3 className="text-center mb-4 text-secondary" style={{ textTransform: 'uppercase', fontSize: '.9rem' }}>Kategori kemampuan berdasarkan hasil jawab</h3>
                        <table className="table table-bordered" style={{ margin: "auto", width: "100%" }}>
                            <thead>
                                <tr>
                                    <th rowSpan={2} className="text-center" style={{ width: "40%" }}>Kategori Soal</th>
                                    <th colSpan={5} className="text-center">Skor total benar</th>
                                </tr>
                                <tr>
                                    <th className="text-center" style={{ width: "12%" }}>RS</th>
                                    <th className="text-center" style={{ width: "12%" }}>R</th>
                                    <th className="text-center" style={{ width: "12%" }}>S</th>
                                    <th className="text-center" style={{ width: "12%" }}>T</th>
                                    <th className="text-center" style={{ width: "12%" }}>TS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hasil !== null && Object.entries(hasil['Karakter Pribadi']).map(([key, value]) => {
                                    return (
                                        <tr key={key}>
                                            <td className="text-center">{key}</td>
                                            <td className="text-center" style={{ position: 'relative' }}>
                                                {(() => {
                                                    let nilai = Object.keys(value['List Point Kategori']);
                                                    let grafik = value['Grafik'];
                                                    let index = nilai.indexOf(grafik);

                                                    return (
                                                        <span className="bg-primary" style={{ position: 'absolute', top: '30%', left: 0, width: ((index + 1) * 100) + '%', height: '18px' }}></span>
                                                    )
                                                })()}
                                            </td>
                                            <td className="text-center">

                                            </td>
                                            <td className="text-center">

                                            </td>
                                            <td className="text-center">

                                            </td>
                                            <td className="text-center">

                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="row container mx-auto mt-3 mb-3 border rounded p-5 bg-white">
                <div className="row mx-auto mt-2">
                    <h2 className="text-center mb-5">Potensi Kerja</h2>
                </div>
                <div className="row mx-auto mt-2">
                    <Bar options={{
                        responsive: true,
                        plugins: {
                                legend: {
                                    display: false,
                                }
                            },
                            scales: {
                                x: {
                                    border: {
                                        display: false,
                                    },
                                    grid: {
                                        display: false,
                                    }
                                },
                                y: {
                                    border: {
                                        display: false
                                    },
                                }
                            }
                        }}
                        data={{
                            labels: hasil !== null ? Object.keys(hasil['Potensi Kerja']).map((key) => 'Kolom ' + key) : [],
                            datasets: hasil !== null ? [
                                {
                                    label: 'Benar',
                                    data: Object.values(hasil['Potensi Kerja']).map((value) => value['Benar']),
                                    backgroundColor: 'rgb(0, 204, 102)',
                                    borderRadius: 10,
                                },
                                {
                                    label: 'Salah',
                                    data: Object.values(hasil['Potensi Kerja']).map((value) => value['Salah']),
                                    backgroundColor: 'rgb(255, 99, 132)',
                                    borderRadius: 10,
                                },
                            ] : []
                        }}
                    />
                </div>
                <div className="row mx-auto my-5">
                    <table className="table table-bordered" style={{ margin: "auto" }}>
                        <thead>
                            <tr>
                                <th className="text-left">Kolom</th>
                                <th className="text-left">Benar</th>
                                <th className="text-left">Salah</th>
                            </tr>
                        </thead>
                        <tbody>
                            {hasil !== null && Object.entries(hasil['Potensi Kerja']).map(([key, value]) => {
                                return (
                                    <tr key={key}>
                                        <td className="text-left">Kolom {key}</td>
                                        <td className="text-left">{value['Benar']}</td>
                                        <td className="text-left">{value['Salah']}</td>
                                    </tr>
                                )
                            })}
                            <tr>
                                <td className="text-left"><strong>Total</strong></td>
                                <td className="text-left"><strong>{hasil !== null ? Object.values(hasil['Potensi Kerja']).reduce((prev, curr) => prev + curr['Benar'], 0) : 0}</strong></td>
                                <td className="text-left"><strong>{hasil !== null ? Object.values(hasil['Potensi Kerja']).reduce((prev, curr) => prev + curr['Salah'], 0) : 0}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> */}
            {(() => {
                switch (user.version) {
                    case 'potential-test':
                        return <PotentialTestFinish data={hasil} />;
                    case 'potensi-kerja':
                        return <PotensiKerjaFinish data={hasil} />;
                    case 'spesial-potential-test':
                        return <SpecialPotentialTestFinish data={hasil} />;
                    case 'tes-akademik':
                        return <TesAkademikFinish data={hasil} />;
                    default:
                        return null;
                }
            })()}
        </Layout>
    )
}
